import { Box } from "@mui/material";
import React from "react";
import { Style } from "./style";

const IconCircle = ({ icon }) => <Box sx={Style.main}>{icon}</Box>;
export default IconCircle;
